import { Typography, useTheme } from "@mui/material";

const TitleDescription = ({
    description,
    textAlign
}) => {
    const theme = useTheme();

    return (
        <>
            <Typography
                fontWeight={400}
                fontSize={{xs: 12, md: 16}}
                lineHeight={1.5}
                textAlign={{xs: 'center', md: textAlign}}
                color={theme.palette.text.secondary}
                data-aos="slide-up"
                data-aos-delay="100"
            >
                {description}
            </Typography>
        </>
    );
}

export default TitleDescription;